<template>
	<div id="UsuariosIndex">
		<usuario-quicktable />
	</div>
</template>

<script>
import usuarioQuicktable from './assets/usuarioQuicktable.vue'
export default {
	components: { usuarioQuicktable },
	name: 'UsuariosIndex'
}
</script>